import { IconModel } from '../icon.model';
import { LocalizedValueModel } from '../localized-value.model';
import { RefProperty } from '../ref-property.model';
import { DataEntryPresenterModel } from './data-entry-presenter.model';

export class TimelinePostPresenterModel<
  T = unknown,
> extends DataEntryPresenterModel {
  override dataEntity: 'POSTS';
  override value: TimelinePostValuePresenterModel<T>;
}

export interface PostActionInfo {
  doneAt: Date;
  doneBy: RefProperty;
}
export interface TimelinePostValuePresenterModel<T = unknown> {
  reference: RefProperty;
  module: RefProperty;
  title: LocalizedValueModel;
  description?: LocalizedValueModel;
  attributes: T;
  timelineConfig?: TimelinePostConfig;
  pinned?: boolean;
  publishState?: PublishState;
  publishInfo?: PostActionInfo;
  unpublishInfo?: PostActionInfo;
  published?: boolean;
}

export interface PublishState {
  manual?: boolean;

  scheduled?: {
    publishDate?: Date;
    unpublishDate?: Date;
    published?: boolean;
  };
  workflow?: {
    currentStep?: string;
    currentStepName?: LocalizedValueModel;
    published?: boolean;
  };
}
export interface TimelinePostConfig {
  /**
   * The category for this post
   */
  category: RefProperty;
  /**
   * The title for the timeline entry as defined in the entity timeline contribution
   */
  title: LocalizedValueModel;
  /**
   * The icon for the timeline entry as defined in the entity timeline contribution
   */
  icon: IconModel;

  publishConfig: {
    [Prop in keyof TimelinePostPublishConfigModel]: boolean;
  };
}

export class TimelinePostPublishConfigModel {
  /**
   * Whether the manual publish option is available or not.
   */
  manual: boolean;
  publishDate?: TimelinePublishDateConfigModel;
  unpublishDate?: TimelinePublishDateConfigModel;
  workflow?: TimelinePublishWorkflowConfigModel;
}

export type TimelinePublishDateConfigModel = {
  /**
   * 0 => Fixed
   * 1 => Dynamic
   * Fixed is not supported yet.
   */
  mode: 0 | 1;

  /**
   * Either the normalized field path if mode is Dynamic or the fixed date value if mode is Fixed.
   */
  value: string;
};

export type TimelinePublishWorkflowConfigModel = {
  publishStepIds: Array<string>;
};
